export default __webpack_public_path__ + "static/media/mri_id.1103b264.csv";